import { connect } from "react-redux"

import {
    stakeholderAddNew,
    stakeholderListInvalidationRequest,
    stakeholderListRequest,
    stakeholderListSearchRequest,
    stakeholderSetFilter
} from "../../../actions/stakeholder-actions"
import StakeholderListWidget from "./StakeholderListWidget"

const mapStateToProps = ({
    presentation: { stakeholders },
    paging,
    authentication
}) => ({
    isFetching: stakeholders.isFetchingList || stakeholders.isFetchingItem,
    pagingRequest: paging.stakeholders[stakeholders.searchCriteria] || {},
    nameSearchTerm: stakeholders.workingFilterModel.full_name,
    isEmptySearchValue: stakeholders.workingFilterModel.empty,
    canAdd: authentication.permissions.indexOf("w_stakeholder") !== -1
})

const mapDispatchToProps = dispatch => ({
    invalidate: pagingRequest => () =>
        dispatch(stakeholderListInvalidationRequest(pagingRequest)),
    onFilterSelect: pagingRequest => () =>
        dispatch(stakeholderSetFilter(true, pagingRequest.searchCriteria)),
    onSearch: ({ target: { name, value } }) =>
        dispatch(stakeholderListSearchRequest(name, value)),
    loadList: () => dispatch(stakeholderListRequest()),
    onAdd: () => dispatch(stakeholderAddNew())
})

export default connect(mapStateToProps, mapDispatchToProps)(
    StakeholderListWidget
)
